import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Image } from 'components/core/Image';

import './imageBadge.scss';

export function ImageBadge({
	className,
	icon,
	isFacilityCard,
	color,
	lazyLoad
}) {
	return (
		<div className={classnames('image-badge')}>
			<Image
				src={icon}
				className={classnames(
					'badge',
					className,
					{ 'is-facility-card-badge': isFacilityCard },
					!!color && `sf-badge-${color}`
				)}
				lazyLoad={lazyLoad}
			    alt="icon"
			/>
		</div>
	);
}

ImageBadge.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.string.isRequired,
	isFacilityCard: PropTypes.bool,
	color: PropTypes.string,
	lazyLoad: PropTypes.bool,
	
};

export default ImageBadge;
